import { TextInput, TextInputProps } from '@mantine/core';

type TextSettingProps = {
  onChange: (option: string) => void;
  value: string;
};

export function TextSetting({ onChange, value, title, ...props }: TextSettingProps & TextInputProps) {
  return <TextInput value={value} onChange={(event) => onChange(event.target.value)} {...props} />;
}
